export const BORROWED_CHORDS = {
  C: ["Cm", "Cm7", "Fm", "Fm7", "Ab", "AbM7", "Bb", "Bb7"],
  G: ["Gm", "Gm7", "Cm", "Cm7", "Eb", "EbM7", "F", "F7"],
  D: ["Dm", "Dm7", "Gm", "Gm7", "Bb", "BbM7", "C", "C7"],
  A: ["Am", "Am7", "Dm", "Dm7", "F", "FM7", "G", "G7"],
  E: ["Em", "Em7", "Am", "Am7", "C", "CM7", "D", "D7"],
  B: ["Bm", "Bm7", "Em", "Em7", "G", "GM7", "A", "A7"],
  "F#": ["F#m", "F#m7", "Bm", "Bm7", "D", "DM7", "E", "E7"],
  F: ["Fm", "Fm7", "Bbm", "Bbm7", "Db", "DbM7", "Eb", "Eb7"],
  Bb: ["Bbm", "Bbm7", "Ebm", "Ebm7", "Gb", "GbM7", "Ab", "Ab7"],
  Eb: ["Ebm", "Ebm7", "Abm", "Abm7", "Cb", "CbM7", "Db", "Db7"],
  Ab: ["Abm", "Abm7", "Dbm", "Dbm7", "Fb", "FbM7", "Gb", "Gb7"],
  Db: ["Dbm", "Dbm7", "Gbm", "Gbm7", "Bbb", "BbbM7", "Cb", "Cb7"],
  Gb: ["Gbm", "Gbm7", "Cbm", "Cbm7", "Ebb", "EbbM7", "Fb", "Fb7"],
  Am: ["A", "AM7", "D", "DM7", "E", "E7"],
  Em: ["E", "EM7", "A", "AM7", "B", "B7"],
  Bm: ["B", "BM7", "E", "EM7", "F#", "F#7"],
  "F#m": ["F#", "F#M7", "B", "BM7", "C#", "C#7"],
  "C#m": ["C#", "C#M7", "F#", "F#M7", "G#", "G#7"],
  "G#m": ["G#", "G#M7", "C#", "C#M7", "D#", "D#7"],
  "D#m": ["D#", "D#M7", "G#", "G#M7", "A#", "A#7"],
  Dm: ["D", "DM7", "G", "GM7", "A", "A7"],
  Gm: ["G", "GM7", "C", "CM7", "D", "D7"],
  Cm: ["C", "CM7", "F", "FM7", "G", "G7"],
  Fm: ["F", "FM7", "Bb", "BbM7", "C", "C7"],
  Bbm: ["Bb", "BbM7", "Eb", "EbM7", "F", "F7"],
  Ebm: ["Eb", "EbM7", "Ab", "AbM7", "Bb", "Bb7"],
};